<template>
    <input type="text"
           name
           id
           maxlength="10"
           pattern="\d*"
           :placeholder="translations.SearchMatNr"
           class="px-2.5 py-1.5 text-sm w-full rounded t3m-ObjectiveFinder-materialnumber border-t3m-border-color focus:ring-t3m-input-focus-ring-color focus:border-t3m-input-focus-ring-color placeholder:truncate"
           v-model="searchTerm" />
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "SearchFilter",
    data() {
        return {
            materialnumber: "",
            searchTerm: "",
            filterItemSettings: {
                id: "uid-matnrShort",
                type: "fuzzyString",
                targetProperty: "matnrShort",
                values: [""],
            },
        };
    },
    computed: {
        ...mapState(["translations"])
    },
    mounted() {
        this.registerSearchComponent(this);
    },
    methods: {
        ...mapActions([
            "registerSearchComponent",
            "addAppliedFilter",
            "removeAppliedFilter",
        ]),
        logCheckedFilterOptions() {
            this.removeAppliedFilter(this.filterItemSettings);

            if (this.searchTerm.length > 2) {
                this.filterItemSettings.values = [this.searchTerm];
                this.addAppliedFilter(this.filterItemSettings);
            }
        },
        clear() {
            this.searchTerm = "";
        },
    },
    watch: {
        searchTerm: function () {
            if (this.searchTerm.length > 6) {
                alert('You have entered too many digits. Please enter the last 6 digits of the material number only.');
                this.searchTerm = this.searchTerm.slice(0, 6);
            }
            this.logCheckedFilterOptions();
        },
    },
};
</script>
